export enum DialogActionsEnum {
  open = 'open',
  close = 'close',
  refresh = 'refresh',
}

export interface IDialogTrigger {
  type: string;
  action: DialogActionsEnum;
  emitEvent: boolean;
  data?: any;
}

export interface IDialogData {
  result: boolean | null;
}

export const DIALOG_ANIMATE_TIME = 500;
export const DIALOG_CLASS = '.vex';
